// extracted by mini-css-extract-plugin
export default {"table":"Home_table__JVGuC","customHr":"Home_customHr__HKUa1","spacer":"Home_spacer__nJLzE"};